import { useEffect } from "react";

const SITE = "Sitepar";

function setTag(selector, attrs) {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement(attrs.tag);
    document.head.appendChild(el);
  }
  Object.entries(attrs).forEach(([k, v]) => { if (k !== "tag" && v != null) el.setAttribute(k, v); });
  return el;
}

// Imperative, dependency-free SEO: title, description, canonical, Open Graph, Twitter, JSON-LD.
export function useSeo({ title, description, image, type = "website", canonical, jsonLd } = {}) {
  useEffect(() => {
    const fullTitle = title ? (title.includes(SITE) ? title : `${title} · ${SITE}`) : `${SITE} · Construction Operating System`;
    document.title = fullTitle;
    const url = canonical || window.location.href.split("#")[0];
    if (description) setTag('meta[name="description"]', { tag: "meta", name: "description", content: description });
    setTag('meta[property="og:title"]', { tag: "meta", property: "og:title", content: fullTitle });
    if (description) setTag('meta[property="og:description"]', { tag: "meta", property: "og:description", content: description });
    setTag('meta[property="og:type"]', { tag: "meta", property: "og:type", content: type });
    setTag('meta[property="og:url"]', { tag: "meta", property: "og:url", content: url });
    if (image) setTag('meta[property="og:image"]', { tag: "meta", property: "og:image", content: image });
    setTag('meta[name="twitter:title"]', { tag: "meta", name: "twitter:title", content: fullTitle });
    if (description) setTag('meta[name="twitter:description"]', { tag: "meta", name: "twitter:description", content: description });
    if (image) setTag('meta[name="twitter:image"]', { tag: "meta", name: "twitter:image", content: image });
    setTag('link[rel="canonical"]', { tag: "link", rel: "canonical", href: url });

    let ld = document.getElementById("sitepar-jsonld");
    if (jsonLd) {
      if (!ld) { ld = document.createElement("script"); ld.id = "sitepar-jsonld"; ld.type = "application/ld+json"; document.head.appendChild(ld); }
      ld.textContent = JSON.stringify(jsonLd);
    } else if (ld) { ld.remove(); }
  }, [title, description, image, type, canonical, jsonLd]);
}
